/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2021-12-08 17:35:41
 * @LastEditors: Mayer
 * @LastEditTime: 2023-10-12 11:56:03
 */
const countryList: any = {
  470: { countryName: 'Bangladesh', areaTel: "880", telength: ["10"], },
  612: { countryName: "Cote d'Ivoire", areaTel: "225", telength: ["10"], },
  620: { countryName: "Ghana", areaTel: "233", telength: ["9"], },
  510: { countryName: "Indonesia", areaTel: "62", telength: ["10", "11", '12', '13'], },
  639: { countryName: "Kenya", areaTel: "254", telength: ["9"], },
  621: { countryName: "Nigeria", areaTel: "234", telength: ["10"], },
  410: { countryName: "Pakistan", areaTel: "92", telength: ["10"], },
  640: { countryName: "Tanzania", areaTel: "255", telength: ["9"], },
  515: { countryName: "Philippines", areaTel: "63", telength: ["11"], },
  636: { countryName: "Ethiopia", areaTel: "251", telength: ["9"], },
  645: { countryName: "Zambia", areaTel: "260", telength: ["9"], },
  646: { countryName: "Madagascar", areaTel: "261", telength: ['9', "10"], },
  404: { countryName: "India", areaTel: "91", telength: ["10"], },
  405: { countryName: "India", areaTel: "91", telength: ["10"], },
  406: { countryName: "India", areaTel: "91", telength: ["10"], },
  520: { countryName: "Thailand", areaTel: "66", telength: ["9", "10"], },
}


export { countryList };